import React from "react";
import { Container, Button } from "shards-react";

const Errors = () => (
  <Container fluid className="main-content-container px-4 pb-4">
    <div className="error">
      <div className="error__content">
        <h2>404</h2>
        <h3>Algo salió mal</h3>
        <p>Ups! Hubo algun problema, por favor volver a intentar .</p>
        <Button pill href="/contracts">&larr; Volver</Button>
      </div>
    </div>
  </Container>
);

export default Errors;
